import { Arrows } from "..";
import Add from "../../../../../assets/icons/Add";
import { Anchor, Container, Content } from "./styles";

export function Parallel({ job, theme }) {
  const cellWidth = parseInt(theme.cellWidth);
  const startTime = job.start.getHours();
  const leftOffset = (startTime * cellWidth) / 24 + 10.5;
  const status = job.status;

  const AddStyle = {
    transform: "rotate(45deg)",
    width: theme.parallelStyle.iconSize,
    height: theme.parallelStyle.iconSize,
  };

  return (
    <Container style={{

      top: theme.parallelStyle.top,
      left: leftOffset + "px"
    }}>
      <Content style={{
        width: theme.parallelStyle.width,
        height: theme.parallelStyle.height,
      }} status={status}>
        <Anchor className="top_anchor" id={"anchor_" + job.id} />
        <Anchor className="bottom_anchor" id={job.id} />
        <Add color="#111" style={AddStyle} />
      </Content>
      <Arrows job={job} />
    </Container>
  );
}
